import { isTerminalExecution } from "../domain/executionReconciliation";
import { selectLocalOpenExecutions } from "../recovery/localRecoveryProbe";

// What Home reads from this device's Workout Log store (blueprint §15.9 D3,
// §8.5). Read-only: Home never writes, finalizes, locks or syncs a record, and
// never classifies one as Planned or Extra.

function isPendingSaved(record) {
  return record?.document?.status === "SAVED" &&
    Number(record.localRevision || 0) > Number(record.ackedRevision || 0);
}

// True once the SAVED document of this record has been acknowledged.
export function isAcknowledgedSaved(record) {
  return record?.document?.status === "SAVED" &&
    Number(record.localRevision || 0) <= Number(record.ackedRevision || 0);
}

export function summarizeLocalRecords(records = []) {
  const [open] = selectLocalOpenExecutions(records);
  return {
    // The record TRAIN itself would recover first (same selection, same order).
    openExecution: open
      ? {
        executionId: open.executionId,
        title: open.document?.title || open.server?.title || null,
        status: open.document.status,
        source: "local",
      }
      : null,
    pendingSavedCount: records.filter(isPendingSaved).length,
  };
}

export async function readHomeLocalState(store, userId) {
  if (!userId) return summarizeLocalRecords([]);
  return summarizeLocalRecords(await store.listExecutions(userId));
}

// Local terminal precedence (§8.5): a SAVED or DISCARDED record on this device
// is the truth for its executionId, so the server's older open copy of it is
// never offered again.
export function selectServerOpenExecution(openExecutions = [], records = []) {
  const locallyTerminal = new Set(
    records.filter(isTerminalExecution).map((record) => record.executionId)
  );
  const entry = (openExecutions || [])
    .map((candidate) => candidate?.summary || candidate)
    .find((candidate) => candidate?.executionId && !locallyTerminal.has(candidate.executionId));
  return entry
    ? {
      executionId: entry.executionId,
      title: entry.title || null,
      status: entry.status,
      source: "server",
    }
    : null;
}
